import {
    FT5_ADD_ACTION_TO_EVENT_TRACKING,
    FT5_ADD_TO_EVENT_TRACKING,
    FT5_EVENT_TRACKING,
    FT5_MOVE_ACTION_TRACKING,
    FT5_MOVE_TRACKING,
    FT5_TRACK_ON_NEXT_PAGE_IMPRESSION,
} from '../../constants';
import { TrackingDataExtractor } from './tracking-data-extractor';
import { VariationIdEnhancer } from './variation-id-enhancer';
import { NamedTrackingFeatures } from './event-data-types';
import { VariationDataEnhancer } from './variation-data-enhancer';
import {
    Action,
    ActionName,
    DataContainer,
    submitEvent,
    submitMove,
    submitEventMerge,
    trackOnNextPageImpression,
} from '@otto-ec/tracking-bct';

const DATA_ATTRIBUTE_CLICK_TRACKING = 'data-ft5-click-tracking';

export class EventTracking {
    constructor(
        private trackingDataConverter: TrackingDataExtractor,
        private variationIdEnhancer: VariationIdEnhancer,
        private variationDataEnhancer: VariationDataEnhancer
    ) {}

    public delegateHtmlClickTracking(): void {
        const trackClickHandler = (event: MouseEvent) => {
            if (!(event.target instanceof Element)) {
                return;
            }
            this.trackWithParentsRecursive(event.target);
        };

        document.documentElement.addEventListener('click', trackClickHandler, { passive: true, capture: true });
    }

    public registerEventTrackingFromCode(): void {
        o_global.eventQBus.on(FT5_EVENT_TRACKING, (trackingData: DataContainer) => {
            submitEvent(this.variationIdEnhancer.enhance(trackingData), {
                name: 'click',
                features: this.variationDataEnhancer.enhance({}).features || [],
            });
        });

        o_global.eventQBus.on(FT5_MOVE_ACTION_TRACKING, (dataContainer: DataContainer, action: Action) => {
            const variationId = this.variationIdEnhancer.enhance({}).product_VariationId;
            if (variationId === undefined) {
                console.error('Could not retrieve variationId to add to move action');
                return;
            }
            submitMove(
                { ...dataContainer, product_VariationId: [variationId] },
                {
                    name: action.name,
                    features: action.features.concat(this.variationDataEnhancer.enhance({}).features || []),
                }
            );
        });

        o_global.eventQBus.on(FT5_MOVE_TRACKING, (trackingData: DataContainer) => {
            submitMove(this.variationIdEnhancer.enhance(trackingData));
        });

        o_global.eventQBus.on(FT5_ADD_TO_EVENT_TRACKING, (trackingData: DataContainer, actionName: ActionName, eventMergeId: string) => {
            const additionalTrackingFeatures = this.variationDataEnhancer.enhance({}).features || [];
            if (additionalTrackingFeatures.length > 0) {
                submitEventMerge(eventMergeId, this.variationIdEnhancer.enhance(trackingData), {
                    name: actionName,
                    features: additionalTrackingFeatures,
                });
            } else {
                submitEventMerge(eventMergeId, this.variationIdEnhancer.enhance(trackingData));
            }
        });

        o_global.eventQBus.on(FT5_ADD_ACTION_TO_EVENT_TRACKING, (data: NamedTrackingFeatures, eventMergeId: string) => {
            const additionalVariationFeatures = this.variationDataEnhancer.enhance({}).features || [];
            submitEventMerge(eventMergeId, {}, { name: data.name, features: data.features.concat(additionalVariationFeatures) });
        });

        o_global.eventQBus.on(FT5_TRACK_ON_NEXT_PAGE_IMPRESSION, (dataContainer: DataContainer) => {
            trackOnNextPageImpression(dataContainer);
        });
    }

    private trackClick(element: Element) {
        const trackingData = this.trackingDataConverter.extractTrackingData(element, DATA_ATTRIBUTE_CLICK_TRACKING);
        if (trackingData) {
            submitEvent(this.variationIdEnhancer.enhance(trackingData), {
                name: 'click',
                features: this.variationDataEnhancer.enhance({}).features || [],
            });
        }
    }

    /**
 *
 *
 */
    private trackWithParentsRecursive(element: Element) {
        if (element.hasAttribute(DATA_ATTRIBUTE_CLICK_TRACKING)) {
            this.trackClick(element);
        }
        if (element.parentElement) {
            this.trackWithParentsRecursive(element.parentElement);
        }
    }
}
